import { Toast } from "mint-ui";
export const isWechats = () => {
  const _userAgent = window.navigator.userAgent;
  return /MicroMessenger/.test(_userAgent);
};
export const stopPcWechats = () => {
  if (isWechats()) {
    if (
      window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      return true;
    } else {
      Toast({
        message: "请前往手机微信公众号进行下单支付!",
        position: "center",
        duration: 3000,
      });
      return false;
    }
  }
};
export default {
  isWechats,
  stopPcWechats,
};
